import { render } from "./AppSidebarNav.vue?vue&type=template&id=4b5ce7ec&ts=true"
import script from "./AppSidebarNav.vue?vue&type=script&lang=ts"
export * from "./AppSidebarNav.vue?vue&type=script&lang=ts"

import exportComponent from "/home/viper/Projects/topway/topway-accounting-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__